import { Link } from "react-router-dom";
import { quickEntries } from "@/mocks/home";

export default function QuickEntries() {
  return (
    <section className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-5">
      {quickEntries.map((entry) => (
        <Link
          key={entry.key}
          to={entry.to}
          className="group flex flex-col items-start gap-3 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50 md:p-5"
        >
          <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50 transition-transform group-hover:-translate-y-0.5 md:h-12 md:w-12">
            <i className={`${entry.icon} text-2xl`} aria-hidden="true"></i>
          </span>
          <div>
            <h3 className="text-sm font-semibold text-foreground-950 md:text-base">
              {entry.label}
            </h3>
            <p className="mt-1 text-xs text-foreground-500 md:text-sm">{entry.desc}</p>
          </div>
        </Link>
      ))}
    </section>
  );
}